import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';

export type TAddResourceFeedback = {
  feedback: string;
  subTopic: string;
  subTopicName: string;
};

const apiDataProvider = new APIDataProvider();

export const AddResourceFeedback = createAsyncThunk(
  '/resourceFeedback/add',
  async (data: TAddResourceFeedback) => {
    const response = await apiDataProvider.post<
      TApiResponse<TAddResourceFeedback>
    >(ApiPaths.resourceFeedback, data);

    return response.data;
  }
);

export default AddResourceFeedback;
